import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import filterList from '../../../common/actions/lists';
import { parseQuery } from '../../../common/services/parseQuery';
import { IRootState } from '../../../typings';
import { addAgentCompany, fetchAgentCompanies } from '../actions';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  addAgentCompany,
  fetchAgentCompanies,
  filterList,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  return {
    agentCompanies: state.agentCompanies.list,
    fetching: state.agentCompanies.fetching,
    pagination: state.agentCompanies.pagination,
    total: state.agentCompanies.totalItems,
    query: parseQuery(ownProps.location.search),
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
